import React, { useEffect, useMemo, useState, FC } from 'react';
import {
  Container,
  TextField,
  Box,
  Tabs,
  Tab,
  InputAdornment,
  Button,
  IconButton,
} from '@mui/material';
import StyledBox from 'views/rebranded-module/information-module/FaqsViewV2/components/FaqsDetailsSection/FaqsDetailsSection.styles';
import { Typography700, Faq } from 'views/rebranded-module/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { PAGE_STATES } from 'views/rebranded-module/information-module/FaqsViewV2/utils/constants';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import { RiSearchLine, RiCloseLine } from 'react-icons/ri';
import { FaqsDetailsProps } from 'views/rebranded-module/information-module/FaqsViewV2/components/FaqsDetailsSection/FaqsDetailsSection.types';

const FaqsDetailsSection: FC<FaqsDetailsProps> = (props) => {
  const {
    pageState,
    faqs,
    searchKeyword,
    typeId,
    faqsTabs,
    handleSearchQueryClick,
    handleTypeTabClick,
  } = props;
  const content = useContent('FAQSPage');
  const [searchQuery, setSearchQuery] = useState(searchKeyword);
  const checkEnter = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      const content = e.target.value;
      handleSearchQueryClick(content);
    }
  };
  const handleClearInput = () => {
    setSearchQuery('');
  };

  const selectedTabValue = useMemo(
    () =>
      typeId ? faqsTabs.find((tab) => tab.id == typeId)?.value : undefined,
    [typeId],
  );
  useEffect(() => {
    setSearchQuery(searchKeyword);
  }, [searchKeyword]);
  return (
    <StyledBox>
      <Container maxWidth="xl">
        {/* Search Input */}
        <Box className="FDSSearchInputContainer">
          <TextField
            className="FDSSearchInput"
            fullWidth
            variant="outlined"
            placeholder={content.searchPlaceholder}
            value={searchQuery}
            onKeyDown={checkEnter}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              endAdornment: searchQuery && (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={handleClearInput}
                    edge="end">
                    <RiCloseLine />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            color="primary"
            variant="contained"
            className="FDSearchBtn"
            onClick={() => handleSearchQueryClick(searchQuery)}>
            <RiSearchLine className="FDSearchBtnIcon" />
          </Button>
        </Box>

        {pageState !== PAGE_STATES.SEARCH && (
          <Box className="FDSTabsContiner">
            <Tabs
              variant="scrollable"
              className="FDSTabs"
              value={pageState === PAGE_STATES.INDEX ? '' : selectedTabValue}>
              {faqsTabs.map((item) => (
                <Tab
                  className="FDSTab"
                  onClick={() => handleTypeTabClick(item.systemIdentifier)}
                  key={item.id}
                  label={item.label}
                  value={item.value}
                  component={NavigatorLink}
                  href={item.path}
                />
              ))}
            </Tabs>
          </Box>
        )}
        {pageState === PAGE_STATES.SEARCH && (
          <Typography700 component="p" variant="h6" className="FDSResultText">
            {content.resultsFor}
            <Typography700 component="span" variant="h6" pl={0.5}>
              {`“${searchKeyword}”`}
            </Typography700>
          </Typography700>
        )}
        <Box className="FDSQuestionsContainer">
          {faqs.map((item) => (
            <Box key={item.id} className="FDSCatigoryContainer">
              {pageState !== PAGE_STATES.SELECTED_CATEGORIES && (
                <Typography700 component="p" variant="h5" className="FDSCatigoryTitle">
                  {item.categories}
                </Typography700>
              )}
              <Faq
                data={item.questions.map((q, index) => ({
                  ...q,
                  id: `${item.id}-${index}`,
                }))}
              />
            </Box>
          ))}
        </Box>
      </Container>
    </StyledBox>
  );
};

export { FaqsDetailsSection };
